import React from 'react';
import { CustomInput } from 'reactstrap';

function Checkbox({ type = 'switch', ...rest }) {
  return <CustomInput type={type} {...rest} />;
}

export default Checkbox;
